import { queryOptions } from "@tanstack/react-query";
import {
  getBookingsByScheduleV2,
  getBookingsByCustomerV2,
  getSessionsByInstructorV2,
  getBookingsByCustomerPackageV2,
  getActivityLogByBookingIdV2,
} from "hooks/api/booking-v2";

export const bookingsByScheduleV2Options = (
  schedule_id: string,
  occurrence_timestamp: string,
) =>
  queryOptions({
    queryKey: ["booking-v2", "schedule", schedule_id, occurrence_timestamp],
    queryFn: () => getBookingsByScheduleV2(schedule_id, occurrence_timestamp),
    enabled: !!schedule_id && !!occurrence_timestamp,
  });

export const bookingsByCustomerV2Options = (
  customer_id?: string,
  filters?: { customer_package_id?: string; instructor_id?: string },
) =>
  queryOptions({
    queryKey: ["booking-v2", "customer", customer_id, filters],
    queryFn: () => getBookingsByCustomerV2(customer_id!, filters),
    enabled: !!customer_id,
  });

export const sessionsByInstructorV2Options = (instructor_id?: string) =>
  queryOptions({
    queryKey: ["booking-v2", "instructor-sessions", instructor_id],
    queryFn: () => getSessionsByInstructorV2(instructor_id!),
    enabled: !!instructor_id,
  });

export const bookingsByCustomerPackageV2Options = (
  customer_package_id?: string,
) =>
  queryOptions({
    queryKey: ["booking-v2", "customer-package", customer_package_id],
    queryFn: () => getBookingsByCustomerPackageV2(customer_package_id!),
    enabled: !!customer_package_id,
  });

export const activityLogByBookingIdV2Options = (bookingId?: string) =>
  queryOptions({
    queryKey: ["booking-v2", "activity-log", bookingId],
    queryFn: () => getActivityLogByBookingIdV2(bookingId!),
    enabled: !!bookingId,
  });
